import { defineQuiz } from "./_schema";
import { boostQuiz } from "./boost";

/**
 * QUIZ-V6-GATED -- a faithful clone of the live Boost quiz (quiz-v6) with an
 * email-capture gate embedded in the `applying` loader (Variant C, hard gate).
 *
 * Everything that routes users -- `questions`, `branching`, `classifier`,
 * `deriveProfile`, `meta`, `capture` -- is reused verbatim from `boostQuiz`
 * (same object references), so this clone is regression-identical to quiz-v6:
 * the persona distribution, deriveProfile histogram, and suppression floor are
 * all the same walks. Only `id` / `slug` differ now that quiz-v6 and its
 * Google, AppLovin, and X copies use the same gate. This surface retains its
 * explicit `emailGate: true`: email is required before the offer destination,
 * with no skip. Submission is deferred until capture so the email lands on
 * the Klaviyo row.
 * There is deliberately NO `experiment` override. This file spreads quiz-v6, so
 * it INHERITS whatever experiment quiz-v6 declares -- which is nothing today
 * (MM-0093 concluded 2026-09-01 with the variant losing and was removed), so
 * the widget never touches window.igData here and pays no resolver poll (rule
 * 24). This list used to name `experiment: undefined` as one of the differences
 * above; that was true only until MM-0093 armed quiz-v6 and enrolled this clone
 * with it. Opting out of a future quiz-v6 test means adding the override back;
 * a gated-vs-ungated split of its own means an `experiment` block here with its
 * own test id.
 *
 * Do NOT edit routing/copy here -- edit `boost.ts` (this clone inherits it) or
 * fork the shared references if the two surfaces need to diverge.
 */
export const quizV6GatedQuiz = defineQuiz({
  ...boostQuiz,
  id: "quiz-v6-gated",
  slug: "quiz-v6-gated",
  emailGate: true,
});
